import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { LinkProps } from "@/components/wpl/link/src";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";

const wrapperStyle = css({
    display: "flex",
    flexDirection: "column",
    padding: "20px"
});

const headerStyle = css({
    textTransform: "uppercase",
    color: wacToken("color.primary.black"),
    fontSize: "0.75rem",
    fontFamily: wacToken("font.charlie.text"),
    fontWeight: 700,
    lineHeight: "1rem"
});

const linkColumnStyle = css({
    display: "grid",
    gridAutoRows: "40px",
    width: "184px"
});

const linkStyle = css({
    "margin": 0,
    "color": wacToken("color.primary.black"),
    "fontSize": ".875rem",
    "alignSelf": "end",
    ":hover": {
        color: wacToken("color.primary.blue")
    }
});
interface DropdownContentSectionProps {
    header: string;
    links: LinkProps[];
}

const DevopsDropdownContentSection = ({
    header,
    links
}: DropdownContentSectionProps) => {
    return (
        <div css={wrapperStyle}>
            <span css={headerStyle}>{header}</span>
            <div css={linkColumnStyle}>
                {links.map((link) => (
                    <a
                        key={link.text}
                        href={link.href}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-event-container="Sub-Nav-link-in-dropdown"
                        css={linkStyle}
                        onClick={link.onClick}
                    >
                        {link.text}
                    </a>
                ))}
            </div>
        </div>
    );
};

export const DevopsDropdown = () => {
    const intl = useIntl();

    return (
        <DevopsDropdownContentSection
            key={"devops"}
            header={intl.formatMessage({
                id: "software-development.subnav.devops.type.header",
                defaultMessage: "devops"
            })}
            links={[
                {
                    text: intl.formatMessage({
                        id: "software-development.subnav.devops.type.continuous-delivery",
                        defaultMessage: "Continuous Delivery"
                    }),
                    href: useLocalizedHref("/continuous-delivery")
                },
                {
                    text: intl.formatMessage({
                        id: "software-development.subnav.devops.type.git",
                        defaultMessage: "Git"
                    }),
                    href: useLocalizedHref("/git")
                }
            ]}
        />
    );
};
